import { Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { useAddressFormFields } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/hooks/useAddressFormFields';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const CancelChangesButton = () => {
  const { reset, getValues } = useFormContext();
  const { setMode } = useAddressContext();
  const { restoreTemporaryCardData } = useAddressFormFields();

  const handleClick = () => {
    reset({ ...getValues() }); // remove isDirty from formState
    setTimeout(() => {
      restoreTemporaryCardData();
    }, 500); // makes animation seamless
    setMode(AddressMode.CONFIRM);
  };

  return (
    <StandardButton size="small" variant="text" color="default" onClick={handleClick}>
      <Box display={'flex'} gridGap={'6px'} alignItems={'center'}>
        <Icon size={16}>close</Icon>
        <Text tId={'CANCEL'} />
      </Box>
    </StandardButton>
  );
};
